// extracted by mini-css-extract-plugin
export default {"breastImg":"health_breastImg__NN1Lf","breast2Img":"health_breast2Img__Rz+hK","breast3Img":"health_breast3Img__A-JxS"};